import { LegalPage, LegalSection } from "@/components/LegalPage";
import { COMPANY } from "@/lib/company";

export default function Refund() {
  return (
    <LegalPage overline="Legal" title="Cancellation & Refund Policy" updated="28 June 2026" testid="refund-page">
      <LegalSection>
        <p>
          This Cancellation &amp; Refund Policy explains how cancellations, refunds and rescheduling work for
          ferry and cruise tickets booked on {COMPANY.brand}, operated by <strong>{COMPANY.legal}</strong>.
          Refund eligibility depends on how far in advance you cancel and the operator's specific rules.
        </p>
      </LegalSection>

      <LegalSection heading="1. Cancellation by the Passenger">
        <p>You may cancel a confirmed booking from the <strong>My Bookings</strong> section. Refunds are calculated on the base fare (convenience fees and payment gateway charges are non-refundable) as per the slab below:</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li><strong>More than 48 hours</strong> before departure — 90% refund of base fare.</li>
          <li><strong>24–48 hours</strong> before departure — 50% refund of base fare.</li>
          <li><strong>Less than 24 hours</strong> before departure — no refund.</li>
          <li><strong>No-show</strong> at the jetty — no refund.</li>
        </ul>
        <p>Premium cruise sailings may carry stricter operator-defined cancellation terms, which are shown at the time of booking.</p>
      </LegalSection>

      <LegalSection heading="2. Cancellation by the Operator">
        <p>If a sailing is cancelled by the operator (due to weather, tides, technical or regulatory reasons), you are entitled to a <strong>100% refund</strong> of the amount paid, or the option to reschedule to the next available sailing at no extra cost.</p>
      </LegalSection>

      <LegalSection heading="3. Refund Timelines">
        <p>Approved refunds are processed to the original payment method within <strong>5–7 business days</strong>. The time for the amount to reflect in your account depends on your bank or card issuer.</p>
      </LegalSection>

      <LegalSection heading="4. Rescheduling">
        <p>Where the operator permits, you may reschedule a booking up to 24 hours before departure, subject to seat availability and any fare difference. Rescheduling charges, if applicable, are shown before you confirm.</p>
      </LegalSection>

      <LegalSection heading="5. How to Request a Refund">
        <p>Cancel directly from <strong>My Bookings</strong>, or email <a href={`mailto:${COMPANY.email}`} className="text-accent font-medium">{COMPANY.email}</a> with your booking reference. For escalations, contact our grievance officer at <a href={`mailto:${COMPANY.grievanceEmail}`} className="text-accent font-medium">{COMPANY.grievanceEmail}</a>.</p>
      </LegalSection>

      <LegalSection heading="6. Non-Refundable Charges">
        <p>Convenience fees, payment gateway charges and any third-party service fees are non-refundable except where a sailing is cancelled by the operator or as required by applicable law.</p>
      </LegalSection>
    </LegalPage>
  );
}
